'use strict';
import firebase from 'firebase/app';
import 'firebase/auth';

export default function getHeader(token = null) {
	return new Promise(async (resolve, reject) => {
		if (token == null) {
			// Get the token and refresh it if it has expired
			token = await firebase.auth().currentUser.getIdToken(true)
		}

		resolve ({
			'headers': {
				"Authorization": "Bearer " + token
			}
		})
	})
 }